import { ROUTES } from "../../../constants/routes"
const ACTIVATE_USER_ENDPOINT = '/users/api/users/token/';

let redirectUrl = "";

export const activateUser = data => {
  const urlProps = []
  if (data.loginHint) {
    urlProps.push("login_hint=" + encodeURIComponent(data.loginHint))
  }
  if (data.redirectUrl != null) {
    urlProps.push("qcRefer=" + encodeURIComponent(data.redirectUrl))
  }

  redirectUrl = "?" + urlProps.join("&")
  
  return dispatch => {
    dispatch({
      type: 'USER_ACTIVATION_TOKEN_STARTED'
    })
    fetch(ACTIVATE_USER_ENDPOINT + data.activationToken, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    })
      .then(response => {
        if (response.status === 403) {
          dispatch({
            type: 'USER_ACTIVATION_TOKEN_FAILURE',
            error: '403'
          });
          return;
        }
        if (response.status > 299) {
          dispatch({
            type: 'USER_ACTIVATION_OTHER_FAILURE',
            error: '500'
          });
          return;
        }
        return window.location.href = `/user/login${redirectUrl}`;
      })
      .catch(error => {
        dispatch({
          type: 'USER_ACTIVATION_OTHER_FAILURE',
          error
        });
      });
  };
};
